import { CardWithHeader } from "lib-core"

export { CardWithHeader }
export default CardWithHeader
